/* NINTE vehicle selector P0-1. Load after theme.min.js with defer. */
(function (window, document, $) {
  'use strict';

  if (!$ || !window.theme || !window.theme.MultiCategory ||
      window.theme.MultiCategory.ninteStateFix) return;

  var controllers = [];

  function clearLegacyCookie() {
    if ($.cookie) {
      $.cookie('multiLevelCategory', '', { expires: -1, path: '/' });
    }
  }

  function readNodes($list) {
    return $list.children('li').map(function () {
      var $item = $(this);
      var $link = $item.children('a').first();
      var title = $link.find('.lang1').first().text() || $link.text();
      return {
        title: $.trim(title),
        link: $link.attr('href') || '',
        children: readNodes($item.children('ul').first())
      };
    }).get();
  }

  function safeUrl(link) {
    link = typeof link === 'string' ? link.trim() : '';
    if (!link || link.charAt(0) === '#' || link.charAt(0) === '?') return null;
    try {
      var url = new window.URL(link, window.location.href);
      if (url.hostname === 'ninteshop.com' || url.hostname === 'www.ninteshop.com') {
        url.hostname = window.location.hostname;
        url.protocol = window.location.protocol;
      }
      if (url.origin !== window.location.origin ||
          !/^\/(collections|products|search)(\/|$)/.test(url.pathname)) return null;
      return url.href;
    } catch (error) {
      return null;
    }
  }

  function prepare(root) {
    var $root = $(root);
    if ($root.data('ninteFilterController')) return null;
    var nodes = readNodes($root.find('nav[id="navPages"]').first().children('ul'));
    var $browse = $root.find('[id="themevale_select-browse"]');
    var $reset = $root.find('[id="themevale_clear-select"]');
    var fields = [1, 2, 3].map(function (level) {
      var $drop = $root.find('[id="themevale_select-level-' + level + '"]');
      var $button = $drop.prev('.da-force-up');
      return {
        $drop: $drop,
        $list: $drop.children('ul'),
        $button: $button,
        label: $.trim($drop.find('li').first().text()) || $.trim($button.text())
      };
    });
    if (!nodes.length || $browse.length !== 1 || $reset.length !== 1 ||
        fields.some(function (field) {
          return field.$drop.length !== 1 || field.$button.length !== 1 ||
            field.$list.length !== 1;
        })) return null;

    var selected = [null, null, null];
    var $status = $('<p>', { role: 'status', 'aria-live': 'polite' }).hide();

    function optionsAt(index) {
      var options = nodes;
      for (var i = 0; i < index; i++) {
        if (!selected[i] || options.indexOf(selected[i]) === -1) return [];
        options = selected[i].children;
      }
      return options;
    }

    function destination() {
      if (!selected[0] || !selected[1]) return null;
      for (var i = 0; i < selected.length; i++) {
        if (selected[i] && optionsAt(i).indexOf(selected[i]) === -1) return null;
      }
      return safeUrl((selected[2] || selected[1]).link);
    }

    function close() {
      fields.forEach(function (field) {
        field.$drop.removeClass('open');
        field.$button.attr('aria-expanded', 'false');
      });
    }

    function render() {
      close();
      $status.hide().text('');
      fields.forEach(function (field, index) {
        var options = optionsAt(index);
        var enabled = index === 0 || options.length > 0;
        field.$button.text(selected[index] ? selected[index].title : field.label)
          .attr({
            role: 'button', tabindex: enabled ? '0' : '-1',
            'aria-expanded': 'false', 'aria-disabled': String(!enabled),
            'aria-label': field.label
          });
        field.$list.empty().append(
          $('<li>').text(field.label).on('click.ninteFilter', function (event) {
            event.preventDefault();
            event.stopPropagation();
            choose(index, null);
          })
        );
        options.forEach(function (node, nodeIndex) {
          $('<li>').attr('data-value', nodeIndex).text(node.title)
            .toggleClass('active', selected[index] === node)
            .on('click.ninteFilter', function (event) {
              event.preventDefault();
              event.stopPropagation();
              choose(index, node);
            }).appendTo(field.$list);
        });
      });
      if (destination()) {
  $browse.removeAttr('aria-disabled');
} else {
  $browse.attr('aria-disabled', 'true');
}
    }

    function choose(index, node) {
      if (index < 0 || index > 2 || index !== Math.floor(index) ||
          (node && optionsAt(index).indexOf(node) === -1)) return;
      selected[index] = node;
      for (var i = index + 1; i < selected.length; i++) selected[i] = null;
      clearLegacyCookie();
      render();
    }

    function install() {
      $root.data('ninteFilterController', true);
      $root.find('.themevale_multilevel-category-filter').append($status);
      $root.find('.loading').hide();
      fields.forEach(function (field) {
        function toggle(event) {
          event.preventDefault();
          event.stopPropagation();
          if (field.$button.attr('aria-disabled') === 'true') return;
          var opened = field.$drop.hasClass('open');
          controllers.forEach(function (controller) { controller.close(); });
          if (!opened) {
            field.$drop.addClass('open');
            field.$button.attr('aria-expanded', 'true');
          }
        }
        field.$button.on('click.ninteFilter', toggle)
          .on('keydown.ninteFilter', function (event) {
            if (event.key === 'Enter' || event.key === ' ') toggle(event);
            if (event.key === 'Escape') close();
          });
      });
      // Replace only the legacy selector's two direct click handlers.
      $browse.off('click').on('click.ninteFilter', function (event) {
        event.preventDefault();
        event.stopPropagation();
        var url = destination();
        if (url) {
          clearLegacyCookie();
          window.location.assign(url);
        } else {
          close();
          $status.text(selected[0] && selected[1] ?
            'This selection needs review. No matching page was opened.' :
            'Select a make and model to view parts.').show();
        }
      });
      $reset.off('click').attr({ 'aria-label': 'Reset vehicle selection', title: 'Reset' })
        .on('click.ninteFilter', function (event) {
          event.preventDefault();
          event.stopPropagation();
          selected = [null, null, null];
          clearLegacyCookie();
          render();
        });
      render();
    }

    return {
      root: root,
      install: install,
      close: close,
      changeOption: function (level, index) {
        if (level < 1 || level > 3 || level !== Math.floor(level) ||
            !Number.isInteger(index) || index < 0) return;
        var node = optionsAt(level - 1)[index];
        if (node) choose(level - 1, node);
      },
      changeOptionAll: function (level) {
        if (level >= 1 && level <= 3) choose(level - 1, null);
      }
    };
  }

  function init() {
    controllers = controllers.filter(function (controller) {
      return document.documentElement.contains(controller.root);
    });
    $('.themevale_MultiCategory').each(function () {
      var controller = prepare(this);
      if (controller) {
        controllers.push(controller);
        controller.install();
      }
    });
    if (controllers.length) clearLegacyCookie();
  }

  var candidates = $('.themevale_MultiCategory').toArray().map(prepare).filter(Boolean);
  if (!candidates.length) return;
  window.theme.MultiCategory = {
    ninteStateFix: true,
    init: init,
    changeOption: function (level, index) {
      if (controllers[0]) controllers[0].changeOption(level, index);
    },
    changeOptionAll: function (level) {
      if (controllers[0]) controllers[0].changeOptionAll(level);
    }
  };
  $(document).on('click.ninteFilter', function () {
    controllers.forEach(function (controller) { controller.close(); });
  }).on('shopify:section:load.ninteFilter', init);
  init();
})(window, document, window.jQuery);
